import React, { useState, MouseEvent, ReactNode } from 'react';
import { Box, Button, Checkbox, FormControlLabel, Menu, MenuItem } from '@mui/material';
import { FilterIcon } from '../Icons';
import CustomButton from '../CustomButton/CustomButton';
import { FilterOptions, SelectedOptions } from '../../pages/Orders/Orders';
import moment from 'moment';
import { truncateField } from '@src/helpers/Helpers';

interface OrderStatusFilterProps {
	rows: any;
	selectedOption: any;
	selectedOptions: any;
	setSelectedOptions: any;
	customStartDate: Date | null;
	customEndDate: Date | null;
	getFilterData: any;
	statusFilterOptions: FilterOptions[];
	style?: React.CSSProperties;
}

const customBackdropStyle: React.CSSProperties = {
	backgroundColor: 'transparent',
};

const OrderStatusFilter: React.FC<OrderStatusFilterProps> = ({
	rows,
	selectedOption,
	selectedOptions,
	setSelectedOptions,
	customStartDate,
	customEndDate,
	getFilterData,
	statusFilterOptions,
	style,
}) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const handleMenuOpen = (event: MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	const handleOptionChange = (option: string) => () => {

		let updatedOptions = {
			...selectedOptions,
			[option]: !selectedOptions?.[option],
		};

		//Applying default
		// if (Object.values(updatedOptions)?.every((value) => value === false)) {
		// 	updatedOptions = { All: true };
		// }
		setSelectedOptions(updatedOptions);
		getFilterData(selectedOption, updatedOptions, rows, customStartDate, customEndDate);
	};

	const handleClear = () => {
		let options = {};
		statusFilterOptions?.forEach((option) => {
			options = { [option?.label]: false };
		});
		setSelectedOptions(options);

		//next call
		getFilterData(selectedOption, null, rows, customStartDate, customEndDate)
	};

	const handleApply = () => {
		getFilterData(selectedOption, selectedOptions, rows, customStartDate, customEndDate);
		setAnchorEl(null);
	};

	return (
		<div style={style}>
			<CustomButton
				color="secondary"
				StartIcon={<FilterIcon />}
				handleClick={handleMenuOpen}
				title="Order Status"
				styles={{ height: '36px' }}
			/>
			<Menu
				MenuListProps={{
					sx: {
						py: '5px',
					},
				}}
				PaperProps={{
					sx: {
						width: '293px',
						borderRadius: '4px',
						mt: 1,
						boxShadow: '0px 10px 25px 0px #0000001A',
					},
				}}
				BackdropProps={{
					style: customBackdropStyle,
				}}
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={handleMenuClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
			>
				<MenuItem
					sx={{
						py: 0,
						':hover': { backgroundColor: 'transparent' },
					}}
				>
					<Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
						{statusFilterOptions?.map((option) => {
							return (
								<FormControlLabel
									sx={{
										width: '100%',
										display: 'flex',
										ml: '5px',
										justifyContent: 'space-between',
										height: '35px',
									}}
									control={
										<Checkbox
											checked={selectedOptions?.[option?.label] || false}
											onChange={handleOptionChange(option?.label)}
										/>
									}
									label={truncateField(option?.label, 25)}
									labelPlacement="start"
								/>
							);
						})}
					</Box>
				</MenuItem>
				<Box
					sx={{
						mt: '8px',
						display: 'flex',
						padding: '6px 16px',
						alignItems: 'center',
						justifyContent: 'space-between',
						borderTop: '1.5px solid #F1F1F1',
					}}
				>
					<Button
						sx={{
							color: 'errorColor.main',
							p: 0,
							height: 'auto',
							justifyContent: 'flex-start ',
							':hover': {
								backgroundColor: 'transparent',
							},
						}}
						onClick={handleClear}
					>
						Clear
					</Button>
					{/* <CustomButton
						title="Apply"
						handleClick={handleApply}
						heightVariant="medium"
						color="primary"
						styles={{
							width: '68px',
							height: '36px',
							background: 'var(--btn-color-grey)',
							color: 'var(--default-text-color)',
							':hover': {
								background: 'var(--btn-hover-color) !important',
							},
						}}
					/> */}
				</Box>
			</Menu>
		</div>
	);
};

export default OrderStatusFilter;
